import { Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';
import { KzIconsRegistryService } from '../../kz-ui/ui/icon/kz-icons-registry.service';
import { kzIconsShare } from '../../kz-ui/ui/icon/generated-icons/kzIcons-share.icon';
import { socialIcons } from '../../kz-ui/ui/icon/groups/kz-icons-group-social';

@Component({
  selector: 'app-social-share',
  templateUrl: './social-share.component.html',
  styleUrls: ['./social-share.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SocialShareComponent {

  @Input() postLink: string;
  @Input() postDescription = '';
  @Input() postMainMediaUrl = '';

  @HostBinding('class.kz-social-share') hostClass = true;

  constructor(
    private kzIconsRegistryService: KzIconsRegistryService,
  ) {
    this.kzIconsRegistryService.registerIcons([...socialIcons, kzIconsShare]);
  }

}
